import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from'@angular/core';
import { HttpClient } from'@angular/common/http';
import { NbDialogService } from'@nebular/theme';
import { CookieService } from'ngx-cookie-service';
import * as _ from'lodash';

@Component({
  selector:'app-select-salesOutlet',
  templateUrl:'./select-salesOutlet.component.html',
  styleUrls: ['./select-salesOutlet.component.scss']
})
export class SelectSalesOutletComponent implements OnInit {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;
  
  //---------"與父組件共用，不可改位址------->---------------------
  @Input() ProductList: Array<any>;  //細項清單

  //-----------------------彈窗----------------------------

  modalRef = null;  //彈窗鉤子
  PdModalRef = null;  //彈窗鉤子

  @ViewChild('Modal') Modal :TemplateRef<any>
  @ViewChild('PdModal') PdModal :TemplateRef<any>

  //--------------------------------------------------------
  //資料清單
  mainDataList: Array<any>; //已選資料
  showList: Array<any>;
  query = {  //查詢選項
    searchKey : "",
    ORG_Company_ID:null
  } 
  status: { //當前狀態
    isSelectAll : boolean //是否已全選
    showType:number // 顯示有選過的
  }
  isChecked: boolean = false;

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
  ) 
  {
    this.query.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
  }


  ngOnInit(): void {
  }


  ngAfterViewInit(){   
    this.onOpen(this.orgData)
  }


  onOpen(dataList) {
    this.mainDataList = _.cloneDeep(dataList)

    //開啟彈窗
    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }


  //區塊 選擇
  onSelect(isChecked: boolean, data) {
    let obj = this.mainDataList.find(y => y.storeName == data.storeName)
    if (isChecked){
      obj.IsSell = true
    }
    else{
      obj.IsSell = false
    }
  }


  //處存區塊
  onSave() {
    this.emitList.emit(this.mainDataList)
    this.modalRef.close()
  }

}
